import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClientProvider } from "react-query";
import { manageBadgesQueryClient } from "../application/queryClients";

import Container from "@material-ui/core/Container";

import ApplicationHeader from "../application/ApplicationHeader";
import ApplicationPanel from "../application/ApplicationPanel";
import ManageBadgesBrowse from "./ManageBadgesBrowse";

const useStyles = makeStyles(theme => ({
  panel: {
    padding: 0,
  },
}));

const ManageBadges = () => {
  const classes = useStyles();

  return (
    <Container id="manage-badges" classes={{ root: classes.panel }}>
      <ApplicationHeader />

      <ApplicationPanel background="white" height="calc(100vh - 200px)">
        <QueryClientProvider client={manageBadgesQueryClient}>
          <ReactQueryDevtools initialIsOpen={false} />

          <ManageBadgesBrowse />
        </QueryClientProvider>
      </ApplicationPanel>
    </Container>
  );
};

export default ManageBadges;
